import React from 'react'
import { Link } from 'react-browser-router'
import '../css/onlinefees.css';

function Onlinefees() {
  return (
    <div className='feesOnline-sec'>
    <div className='tielt-head'>
        <h1>Online Fees Payment</h1>
      </div>
      <div className='payonline-box'>
        <div className='left-side-box'>
         <div className='inner-box'>
         <h3>Payment online with Login Credentials</h3>
         <Link to="http://sanskar.scholarserp.com/" target="_blank"> Pay Now</Link>
         </div> 
         <div className='inner-box'>
         <h3>Payment online with Admission Number
         </h3>
         <Link to="https://erp.sanskarjaipur.com/Account/fee?ins=OTA1YWVlOTktMjM3ZS00MjI2LThmMjAtZjMxNmVjMGRmZGRjNzg3OA==&amp;br=MjA1NzExNmMtMmZiYi00NDllLTlhNDAtMzNjNmRjZjQ5NTYyNzg3OA==&amp;session=2022" target="_blank"> Pay Now</Link>
         <div className='download-app'>
         <h5>Download app from</h5>
         <div className='download-link'>
        <Link to="https://play.google.com/store/apps/details?id=info.sanskar.school" target="_blank" > <img src="../newimg/New Project (2).webp" alt="" /> </Link>
        <Link to="https://apps.apple.com/in/app/scholarserp/id1528575327" target="_blank"><img src="../newimg/New Project (1).webp" alt="" /> </Link>
         </div> 
         </div>
         </div> 
        </div>
        <div className='right-side-box'>
        <dotlottie-player src="https://lottie.host/eb292a03-5da1-43f0-a927-1d17dc30fe86/h7EZjMeBS8.lottie" style = {{ background:"transparent", speed:"1", width: "400px", height: "400px"}} loop autoplay></dotlottie-player>
        </div>
      </div>
      <div className="bankcharges">
        <h3>Bank Charges as per norms if applicable</h3>
        <p>Kindly send your transaction success details on <b>info@sanskarjaipur.com</b></p>
        <p><b>Any parent facing problems to please contact:</b></p>
        <div className='coordinator-details'>
          <div className='coordinators-name'>
            <p>Fees Coordinator</p>
          </div>
          <div className='coordinators-name'>
            <p>Mr. Rakesh Kumar Saini</p>
          </div>
          <div className='coordinators-name'>
            <p>+91 9314744342</p>
          </div>
          <div className='coordinators-name'>
            <p>Accounts Manager</p>
          </div>
          <div className='coordinators-name'>
            <p>	Mr. Deep Chand Soni</p>
          </div>
          <div className='coordinators-name'>
            <p>+91 9829058074</p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Onlinefees;
